import styled from "styled-components";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 100%;
`;

export const Message = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const Icon = styled.div`
    display: flex;
    align-items: center;
    margin: 8px;

    img {
        width: 119px;
        height: 88px;
    }
`;
